<app-barra-consulta *ngIf="!carregando" visible="false" [listagemComFiltros]="getListagemComFiltros()"
    (atualizando)="atualizar($event)" (inserindo)="novo($event)" (definirFiltro)="definirFiltragem()"
    [exibirNovo]="false" [detalhe]="detalhe">
</app-barra-consulta>
<div class="conteudo">
    <app-loading [exibir]="carregando"></app-loading>
    <div *ngIf="!carregando">
        <div class="row mt-2">
        </div>
        <div class="row">
            <div class="col-md">
                <button class="btn btn-outline-secondary btn-sm mb-2 float-left" (click)="exportarExcel()">
                    <em class="fa fa-download fa-xs"></em>
                    Export Excel
                </button>
            </div>
        </div>
        <div class=" table-scroll">
            <div class="table-size">
                
                <app-analise-venda-bi01-lista-grid [dados]="dados_grid" [anoFiltro]="anoFiltro">

                </app-analise-venda-bi01-lista-grid>

            </div>
        </div>
    </div>
</div>